(() => {
  if (window.AvonticRhinoAddons) return;
  const ROOT = '#avontic-primary-product';
  const track = (name, data = {}, options = {}) => { try { window.AvonticAnalytics?.track?.(name, data, options); } catch (_) {} };
  const setup = () => {
    const root = document.querySelector(ROOT);
    const el = root?.querySelector('[data-av-rg-cro-config]');
    const box = root?.querySelector('.av-addons--product-page');
    if (!root || !el || !box) return null;
    return { root, box, c: {
      id: String(el.dataset.productId || ''),
      handle: el.dataset.productHandle || '',
      locale: el.dataset.locale || 'en',
      eyebrow: el.dataset.setupEyebrow || 'Complete the System',
      title: el.dataset.setupTitle || 'Complete Your RhinoGuard Setup',
      intro: el.dataset.setupIntro || 'Optional accessories selected to complement your case and iPad.',
      primary: el.dataset.setupPrimary || 'Recommended First',
      add: el.dataset.setupAdd || 'Add to Setup',
      choose: el.dataset.setupChoose || 'Choose Options',
      review: el.dataset.setupReview || 'Review Option'
    }};
  };
  const put = (el, value) => { if (el && value && el.textContent !== value) el.textContent = value; };
  const hydrate = () => {
    const x = setup();
    if (!x) return;
    const { box, c } = x;
    box.classList.add('av-rg-cro__setup');
    if (c.locale === 'en') {
      put(box.querySelector('.av-addons__eyebrow'), c.eyebrow);
      put(box.querySelector('.av-addons__header h3'), c.title);
      put(box.querySelector('.av-addons__intro'), c.intro);
    }
    const header = box.querySelector('.av-addons__header');
    if (header && !box.querySelector('.av-rg-cro__setup-value')) {
      const value = document.createElement('div');
      value.className = 'av-rg-cro__setup-value';
      ['Model-aware recommendations','Optional additions','One-tap add'].forEach(label => {
        const span = document.createElement('span');
        span.textContent = label;
        value.append(span);
      });
      header.after(value);
    }
    const cards = [...box.querySelectorAll('.av-addons__card')];
    cards.forEach((card, i) => {
      const cartState = card.dataset.setupCartState || 'missing';
      card.classList.toggle('av-rg-cro__setup-primary', i === 0);
      card.classList.toggle('av-rg-cro__setup-added', cartState === 'in-cart');
      if (i === 0 && !card.querySelector('.av-rg-cro__primary-badge')) {
        const badge = document.createElement('span');
        badge.className = 'av-rg-cro__primary-badge';
        badge.textContent = c.primary;
        card.prepend(badge);
      }
      if (c.locale === 'en') {
        const add = card.querySelector('[data-av-recommendation-add] [data-av-recommendation-action-label]');
        if (add && cartState === 'missing') put(add, c.add);
        put(card.querySelector('[data-av-recommendation-choose] span'), c.choose);
        put(card.querySelector('[data-av-review-action] span'), c.review);
      }
    });
    if (box.dataset.avRgTracked === undefined) {
      box.dataset.avRgTracked = '';
      track('av_rhinoguard_setup_funnel_view', { product_id: c.id, product_handle: c.handle, recommendation_count: cards.length }, { oncePerSession: true, dedupeKey: `${c.id}:setup-funnel` });
    }
  };
  document.addEventListener('click', event => {
    const action = event.target instanceof Element ? event.target.closest('.av-addons__action') : null;
    if (!action) return;
    const x = setup();
    if (!x) return;
    const interaction = action.matches('[data-av-recommendation-add]') ? 'addon_add' : action.matches('[data-av-recommendation-choose]') ? 'addon_choose' : action.matches('[data-av-review-action]') ? 'addon_review' : 'addon_action';
    track('av_rhinoguard_funnel_interaction', { product_id: x.c.id, product_handle: x.c.handle, interaction });
  }, true);
  let queued = false;
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; hydrate(); }); } };
  const start = () => { hydrate(); new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start();
  window.AvonticRhinoAddons = Object.freeze({ version: '2026-07-25.1', hydrate: schedule });
})();
